<template>
    <div class="g-content g-autofixheight order">
        <div class="my-order-tabs my-order-tab-1">
            <div class="g-status">
                <a class="arrow-left js-status-left" href="#" @click="swiperPrev">
                    <i class="ico ico-arrow-left"></i>
                </a>
                <a class="arrow-right js-status-right" href="#" @click="swiperNext">
                    <i class="ico ico-arrow-right"></i>
                </a>
                <div class="swiper-container js-status-swiper" id="swiper-tab">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item,index) in pageConf.demandItemList" :key="item.id">
                            <div class="title" :class="{active: index == curSwiper}" @click="changeSwiper(index,item)">
                                {{item.demandItemStatusText}}
                                <span class="num">（{{item.num}}）</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="search f-clearfix">
                <select-box style="font-size: 14px;color:#666" :selectList="allGame" :itemTitle="'游戏'"
                    :selected.sync="orderParams.gameId"></select-box>
                <select-box style="font-size: 14px;color:#666" :selectList="pageConf.demandTypeList"
                    :itemTitle="'订单类型'" :selected.sync="orderParams.type" :placeholder="'请选择订单类型'"></select-box>
                <div class="list list-order-name">
                    <!--<div class="list">-->
                    <p class="name">
                        <label for="name">订单名称</label>
                    </p>
                    <div class="g-select f-fl">
                        <input class="input" name="keyword" type="text" placeholder="请输入订单名称" v-model.trim="orderParams.name">
                    </div>
                </div>
                <div class="inquire">
                    <input class="btn" type="button" value="查询" @click="getPersonDemandList">
                </div>
            </div>
            <ul class="order-list">
                <li class="order-item f-clearfix" v-for="(demandItem,index) in personDemandItemList" :key="index">
                    <a class="click-area" href="javascript:;" @click="viewDemandItemDetail(demandItem)">
                        <div class="item-head">
                            <img :src="demandItem.gameLogo" width="80" height="80">
                        </div>
                        <div class="item-intro">
                            <div class="item-name f-hide-col-1">
                                <p class="link">{{ demandItem.demandItemName}}</p>
                            </div>
                            <div class="order-intro">
                                <span class="order-num">
                                    <span class="order-num-text">单号：</span>
                                    {{ demandItem.id}}
                                </span>
                                <span class="order-type">{{ demandItem.demandItemTypeText }}</span>
                                <span class="order-type order-type-r">{{
                                    getDemandTypeText(demandItem.demandType)}}</span>
                            </div>
                            <div class="date">
                                <span class="date-detail">{{ demandItem.gameName }}</span>
                                {{ demandItem.startTime }}~{{ demandItem.endTime }}
                            </div>
                        </div>
                        <div class="budget">
                            <div class="budget-all">
                                含税总预算
                                <span class="budget-all-num f-hide-col-1">{{
                                    $common.toThousandsFilter(demandItem.initialTaxableTotalBudget) }}</span>
                            </div>
                            <div class="budget-true">
                                含税实际额
                                <span class="budget-true-num f-hide-col-1">{{$common.toThousandsFilter(demandItem.taxableTotalBudget)
                                    }}</span>
                            </div>
                        </div>
                    </a>
                    <!-- 待完成[[ -->
                    <div class="status f-fr" :class="demandItem.statusTextClass">
                        <!--wait-done待完成 -->
                        <div class="status-text">{{ demandItem.statusText }}</div>
                        <div class="operation" v-if="demandItem.operation.length !== 0">
                            <a class="g-btn" href="javascript:;" @click="contribute(demandItem)" v-if="demandItem.operation.includes('contribute')">投稿</a>
                            <a class="g-btn js-upload" href="javascript:;" @click="submitFile(demandItem)"
                                v-if="demandItem.operation.includes('submitFile')">上传验收件</a>
                            <a class="g-btn js-confirm-zero-pop" href="javascript:;" @click="submitCheck(demandItem)"
                                v-if="demandItem.operation.includes('submitCheck')">提交验收</a>
                            <a href="javascript:;" class="g-btn" @click="acceptDemand(demandItem)" v-if="demandItem.operation.includes('acceptDemand')">接受需求</a>
                            <a class="g-btn js-charge" href="javascript:;" @click="confirmCharge(demandItem)"
                                v-if="demandItem.operation.includes('confirmCharge')">确认收款</a>
                            <a class="g-btn js-uncharge" href="javascript:;" @click="confirmUnpaid(demandItem)"
                                v-if="demandItem.operation.includes('confirmUnpaid')">未收到款</a>
                        </div>
                    </div>
                    <!-- 待完成]] -->
                </li>
            </ul>
            <!-- 空数据 start -->
            <div class="empty" v-if="this.personDemandItemList.length==0">
                <img class="empty-img" src="~Assets/img/pages/v4/radar-no-result.png">
            </div>
            <!-- 空数据 end -->
        </div>
        <!-- 分页[[ -->
        <pagination v-if="paginationConf.total >0" :total="paginationConf.total" :page-size="paginationConf.pageSize"
            @change="pageChange" ref="pager"></pagination>
        <!-- 分页]] -->

        <!-- 提交验收弹窗1[[ -->
        <div class="g-popup g-popup-transparent js-popup-confirm-zero f-hide">
            <div class="popup-con confirm-zero-popup">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close"></i>
                </div>
                <h5 class="popup-title">确认提交</h5>
                <p class="confim-content">当前投稿数为“0”，是否提审？</p>
                <div class="btn-group f-clearfix">
                    <a class="g-btn confirm-btn" href="javascript:;">提交</a>
                    <a class="g-btn cancell f-fr" href="javascript:;">取消</a>
                </div>
            </div>
        </div>
        <!-- 提交验收弹窗1]] -->

        <!-- 提交验收成功弹窗[[ -->
        <div class="g-popup g-popup-transparent js-popup-confirm f-hide">
            <div class="popup-con confirm-popup">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close"></i>
                </div>
                <h5 class="popup-title">提交成功</h5>
                <div class="confirm-content">
                    <div class="confirm-ico"></div>
                    <span class="confirm-tip">提交成功,</span>
                    <span class="confirm-tip-text">请等待验收结果</span>
                </div>
            </div>
        </div>
        <!-- 提交验收成功弹窗]] -->

        <!-- 未收到款弹窗[[ -->
        <div class="g-popup g-popup-transparent js-popup-feedback" v-if="modal.showFeedbackUnpaid">
            <div class="popup-con feedback-popup">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close"></i>
                </div>
                <h5 class="popup-title">反馈成功</h5>
                <div class="confirm-content">
                    <div class="confirm-ico"></div>
                    <span class="confirm-tip">反馈成功,</span>
                    <span class="confirm-tip-text">请等待验收结果</span>
                </div>
            </div>
        </div>
        <!-- 未收到款弹窗]] -->

        <!-- 收款成功弹窗[[ -->
        <div class="g-popup g-popup-transparent js-popup-charged" v-if="modal.showPaySucceed">
            <div class="popup-con charged-popup">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close"></i>
                </div>
                <h5 class="popup-title">收款成功</h5>
                <div class="confirm-content">
                    <div class="confirm-ico"></div>
                    <span class="confirm-tip">收款成功,</span>
                    <span class="confirm-tip-text">订单关闭</span>
                </div>
            </div>
        </div>
        <!-- 收款成功弹窗]] -->

        <!-- 接收需求弹窗1[[ -->
        <div class="g-popup g-popup-transparent js-popup1-accept" v-if="modal.showAcceptDemand">
            <div class="popup-con accept-popup">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close"></i>
                </div>
                <h5 class="popup-title">QQ钱包未实名验证，请绑定与TGL一致的信息</h5>
                <div class="confirm-content">
                    <div class="pop-title">
                        QQ钱包实名注册：
                        <span class="font-bold">QQ钱包</span> -
                        <span class="font-bold">设置</span> -
                        <span class="font-bold">实名认证</span> -
                        <span class="font-bold">绑定银行卡</span> -
                        <span class="font-bold">上传身份证照片验证</span>
                        <br>QQ钱包验证后，请重新登录TGL账号。
                    </div>
                    <img class="bind-img" src="~Assets/img/pages/v4/bind1.png">
                </div>
            </div>
        </div>
        <!-- 接收需求弹窗1]] -->

        <!-- 接收需求弹窗2[[ -->
        <div class="g-popup g-popup-transparent js-popup2-accept" v-if="modal.showAcceptDemand">
            <div class="popup-con accept-popup">
                <div class="popup-close js-close-view">
                    <i class="ico ico-close"></i>
                </div>
                <h5 class="popup-title">QQ钱包验证，请绑定与TGL一致的信息</h5>
                <div class="confirm-content">
                    <div class="pop-title">
                        QQ钱包实名注册：
                        <span class="font-bold">QQ钱包</span> -
                        <span class="font-bold">设置</span> -
                        <span class="font-bold">实名认证</span> -
                        <span class="font-bold">注销账号</span> -
                        <span class="font-bold">重新实名</span>
                        <br>QQ钱包验证后，请重新登录TGL账号。
                    </div>
                    <img class="bind-img" src="~Assets/img/pages/v4/bind2.png">
                </div>
            </div>
        </div>
        <!-- 接收需求弹窗2]] -->

        <!-- 上传文件弹窗[[ -->
        <acceptance-file-upload ref="acceptanceFileDialog"></acceptance-file-upload>
        <!-- 上传文件弹窗]] -->
    </div>
</template>

<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/order/order.scss';
@import '~Assets/vendor/swiper/swiper-3.2.7.min.css';
.order-type-r {
    margin-left: 1rem;
}
</style>
<script>
import Swiper from "Assets/vendor/swiper/swiper-3.2.7.min.js";
import selectBox from "Components/v4/dropdown/select_box";
import pagination from "Components/v4/pagination/pagination_v4";
import acceptanceFileUpload from "../acceptance_file_upload";
import {
    AllGame,
    PersonDemandStat,
    PersonDemandArticleList,
    UserOwnDemand,
    PersonDemandList,
    AcceptPersonDemand,
    SubmitPersonDemand,
    ConfirmPayment,
    ConfirmUnpaid,
    PersonAttachmentSubmit,
    PersonAttachmentDelete
} from "Services/getData.js";
export default {
    name: "personal_order.vue",
    data() {
        return {
            allGame: [],
            mySwiper: {},
            curSwiper: 0,
            orderParams: {
                gameId: "",
                type: "",
                status: "",
                name: "", // 订单名称
                page: 1,
                pageSize: 10
            },
            pageConf: {
                demandTypeList: [
                    {
                        name: "内容创作",
                        id: 10
                    },
                    {
                        name: "劳务服务",
                        id: 20
                    },
                    {
                        name: "福利奖金",
                        id: 30
                    },
                    {
                        name: "补贴补偿",
                        id: 40
                    }
                ],
                demandItemList: [],
                demandItemMap: new Map()
            },
            personDemandItemList: [],
            paginationConf: {
                total: 0,
                pageSize: 10
            },
            modal: {
                showFeedbackUnpaid: false,
                showPaySucceed: false,
                showAcceptDemand: false,
                showSubmitCheck: false,
                showSubmitFile: false
            },
            fileUploader: {},
            uploadFileIds: [] // 暂存上传file id
        };
    },
    components: {
        selectBox,
        pagination,
        acceptanceFileUpload
    },
    created() {
        this.getPersonDemandStat().then(() => {
            this.initSwiper();
            this.getPersonDemandList();
        });
    },
    mounted() {
        this.getAllGame();
    },
    methods: {
        reload() {
            this.getAllGame();
            this.getPersonDemandList();
        },
        pageChange(param) {
            this.orderParams.pageSize = param.pageSize;
            this.orderParams.page = param.pageIndex;
            this.getPersonDemandList();
        },
        viewDemandItemDetail(demandItem) {
            if (demandItem.demandType != 10) {
                this.$router.history.push({
                    name: "v4-order-person-service-detail",
                    query: {
                        id: demandItem.id
                    }
                });
            } else {
                this.$router.history.push({
                    name: "v4-order-person-content-detail",
                    query: {
                        id: demandItem.id
                    }
                });
            }
        },
        contribute(demandItem) {
            this.$router.history.push({
                name: "v4-order-contribute",
                query: {
                    demandItemId: demandItem.id,
                    demandType: 1
                }
            });
        },
        submitCheck(demandItem) {
            this.$confirm("确认提交验收吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                closeOnClickModal: false
            })
                .then(() => {
                    this.doSubmitCheck(demandItem.id);
                })
                .catch(() => { });
        },
        acceptDemand(demandItem) {
            this.$confirm("确认接收需求吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                closeOnClickModal: false
            })
                .then(() => {
                    this.doAcceptDemand(demandItem.id);
                })
                .catch(() => { });
        },
        submitFile(demandItem) {
            // this.modal.showSubmitFile = true;
            if (!demandItem.id) {
                this.$alert("参数错误~");
                return false;
            }
            this.$refs.acceptanceFileDialog.showDialog(demandItem.id);
        },
        confirmCharge(demandItem) {
            this.$confirm("确认已经收款吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                closeOnClickModal: false
            })
                .then(() => {
                    this.doConfrimPayment(demandItem.id);
                })
                .catch(() => { });
        },
        confirmUnpaid(demandItem) {
            this.$confirm("确认未收款吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                closeOnClickModal: false
            })
                .then(() => {
                    this.doConfrimUnpaid(demandItem.id);
                })
                .catch(() => { });
        },

        async getAllGame() {
            let res = await AllGame();
            if (res.data && res.data.data.length) {
                this.allGame = res.data.data;
                this.allGame.unshift({
                    id: 0,
                    name: "全部"
                });
            }
        },
        async doAcceptDemand(demandItemId) {
            // demandItemId = 123456;
            let res = await AcceptPersonDemand({
                demandItemId
            });
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    this.reload();
                }
            }
        },
        async doSubmitCheck(demandItemId) {
            // demandItemId = 123456;
            let res = await SubmitPersonDemand({
                demandItemId
            });
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    this.reload();
                }
            }
        },
        async doConfrimPayment(demandItemId) {
            let res = await ConfirmPayment({
                demandItemId
            });
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    this.reload();
                }
            }
        },
        async doConfrimUnpaid(demandItemId) {
            let res = await ConfirmUnpaid({
                demandItemId
            });
            if (res.status === 200 && res.data.code == 0) {
                if (res.data.code == 0) {
                    this.reload();
                }
            }
        },

        async getPersonDemandStat() {
            let res = await PersonDemandStat();
            if (res.status === 200 && res.data.code == 0) {
                this.pageConf.demandItemList = res.data.data;
                let demandItemTextMap = new Map();
                res.data.data.map(item => {
                    demandItemTextMap.set(
                        item.demandItemStatus,
                        item.demandItemStatusText
                    );
                });
                this.pageConf.demandItemMap = demandItemTextMap;
            }
        },
        async getPersonDemandList() {
            let param = this.orderParams;
            let res = await PersonDemandList(param);
            if (res.status === 200 && res.data.code == 0) {
                let data = res.data;
                if (data.code != 0) {
                    // this.$alert(data.info);
                } else {
                    this.personDemandItemList = this.formatDemandItemList(
                        data.data.data
                    );
                    this.paginationConf.total = data.data.total;
                }
            }
        },

        initSwiper() {
            this.mySwiper = new Swiper("#swiper-tab", {
                paginationClickable: true,
                slidesPerView: "auto",
                initialSlide: 1,
                slideToClickedSlide: true,
                centeredSlides: true,
                onTransitionEnd: function (swiper) {
                    if (swiper.progress == 1) {
                        swiper.activeIndex = swiper.slides.length - 1;
                    }
                }
            });
        },
        swiperPrev() {
            this.mySwiper.slidePrev();
        },
        swiperNext() {
            this.mySwiper.slideNext();
        },
        changeSwiper(index, item) {
            this.curSwiper = index;
            this.resetQueryCondition();
            this.orderParams.status = item.demandItemStatus;
            this.getPersonDemandList();
        },
        resetQueryCondition() {
            this.orderParams = {
                gameId: "",
                type: "",
                status: "",
                name: "", // 订单名称
                page: 1,
                pageSize: 10
            };
        },
        formatDemandItemList(demandList) {
            let demandTypeListMap = new Map();
            for (let obj of this.pageConf.demandTypeList) {
                demandTypeListMap.set(obj.id, obj.name);
            }
            return demandList.map(demand => {
                if (demandTypeListMap.has(demand.demandType)) {
                    demand.demandTypeText = demandTypeListMap.get(
                        demand.demandType
                    );
                }
                let status = demand.demandItemStatus;
                demand.statusText = this.getStatusText(status);
                switch (status) {
                    case 2007:
                    case 2008:
                    case 2009:
                        demand.operation = [];
                        demand.statusTextClass = "wait-check";
                        break;
                    case 2010: // 支付成功
                        demand.operation = ["confirmCharge", "confirmUnpaid"];
                        demand.statusTextClass = "charge-success";
                        break;
                    case 2011: // 支付失败
                        demand.operation = [];
                        demand.statusTextClass = "interrupt";
                        break;

                    case 3002: // 中止
                        demand.operation = [];
                        demand.statusTextClass = "interrupt";
                        break;
                    case 3003: // 待接收
                        demand.operation = ["acceptDemand"];
                        demand.statusTextClass = "wait-accept";
                        break;
                    case 3004: // 待完成
                        if (demand.demandType == 10) {
                            //图文
                            demand.operation = ["contribute", "submitCheck"];
                            demand.statusTextClass = "wait-done";
                        } else {
                            demand.operation = ["submitCheck", "submitFile"]; // 投稿、提交验收件
                            demand.statusTextClass = "wait-done";
                        }
                        break;
                    case 3006: // 验收不通过
                        if (demand.demandType == 10) {
                            //图文
                            demand.operation = ["contribute", "submitCheck"];
                            demand.statusTextClass = "wait-check-failure";
                        } else {
                            demand.operation = ["submitCheck", "submitFile"]; // 投稿、提交验收件
                            demand.statusTextClass = "wait-check-failure";
                        }
                        break;
                    case 3005: // 待验收
                        demand.statusTextClass = "wait-check-success";
                    case 3007: // 验收通过
                        demand.statusTextClass = "wait-check-success";
                    case 3010: // 已确认收款
                        demand.statusTextClass = "charge-confirm";
                    case 3011: // 未收款
                        demand.statusTextClass = "charge-none";
                    case 3012: // 已确认未收款
                        demand.operation = [];
                        demand.statusTextClass = "charge-none";
                        break;
                    default:
                        demand.operation = [];
                        demand.statusTextClass = "wait-check";
                        break;
                }
                return demand;
            });
        },
        getStatusText(status) {
            let txt = "";
            if (this.pageConf.demandItemMap.has(status)) {
                txt = this.pageConf.demandItemMap.get(status);
            }
            return txt;
        },
        getDemandTypeText(type) {
            let text = "";
            this.pageConf.demandTypeList.filter(demandType => {
                if (demandType.id == type) {
                    text = demandType.name;
                }
            });
            return text;
        }
    },
    computed: {}
};
</script>


